
import { defineComponent } from 'vue';
import PayModal from '@/components/modal/payModal.vue';
import RenewalUpgrade from './components/renewalUpgrade.vue';
import UserInfoModal from './components/modal/userInfo.vue';
import Footer from './components/footer.vue';

export default defineComponent({
  name: 'CostMode',
  components: {
    RenewalUpgrade,
    Footer,
    PayModal,
    UserInfoModal,
  },
  data() {
    return {
      payInfo: {
        key: '',
      },
    };
  },
  methods: {
    selectedByValue(value: TString) {
      console.log('===>', value);
      this.payInfo = value as never;
    },
    handleToPay() {
      if (this.payInfo.key >= '4') {
        const refs = this.$refs as unknown as {UserInfoModal: {showModal: Function}};
        refs.UserInfoModal.showModal();
      } else {
        const refs = this.$refs as unknown as {payModal: {showModal: Function}};
        refs.payModal.showModal();
      }
    },
  },
});
